// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"df2be62b","377":"eba25f7c","417":"ea47d46b","467":"3eebda22","626":"e5e40771","870":"6cb6f25d"}[chunkId] + ".js";
};